<template>
  <div
    class="flex"
    :class="{ 'flex-col -space-y-2': isVertical, '-space-x-2': !isVertical }"
  >
    <div
      v-if="shouldHideAirlines && !isVertical"
      :class="iconSize"
      class="bg-background-neutral-secondary text-situational-grey border-situational-grey z-[8] flex items-center justify-center rounded-full border font-medium leading-[110%]"
      data-test-id="more-airlines-icon"
    >
      +{{ hiddenAirlinesAmount }}
    </div>
    <AirlineIcon
      v-for="(airline, index) of croppedAirlines"
      :key="airline.iata"
      :airline="airline"
      :size="size"
      :style="`z-index: ${isVertical ? index : croppedAirlines.length - index}`"
      :class="iconSize"
    />
    <!-- in vertical mode element is displayed at the bottom of the list -->
    <div
      v-if="shouldHideAirlines && isVertical"
      :class="iconSize"
      class="bg-background-neutral-secondary text-situational-grey border-situational-grey z-[8] flex items-center justify-center rounded-full border font-medium leading-[110%]"
      data-test-id="more-airlines-icon"
    >
      +{{ hiddenAirlinesAmount }}
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import {
    AirlineIcon,
    AirlineIconSizeEnum,
    type Airline,
  } from '../../../shared/ui';
  import { getIconsDisplayData } from '../lib';

  const props = withDefaults(
    defineProps<{
      airlines: Airline[];
      airlinesToDisplay?: number;
      size?: AirlineIconSizeEnum;
      isVertical?: boolean;
    }>(),
    {
      size: AirlineIconSizeEnum.default,
      airlinesToDisplay: 3,
      noOverlap: false,
    },
  );

  const displayData = computed(() =>
    getIconsDisplayData(props.airlinesToDisplay, props.airlines),
  );

  const shouldHideAirlines = computed(
    () => displayData.value.shouldHideAirlines.value,
  );
  const croppedAirlines = computed(
    () => displayData.value.croppedAirlines.value,
  );
  const hiddenAirlinesAmount = computed(
    () => displayData.value.hiddenAirlinesAmount.value,
  );

  const iconSize = [
    { 'h-4 w-4 text-2xs': props.size === AirlineIconSizeEnum.small },
    { 'h-6 w-6 text-[12px]': props.size === AirlineIconSizeEnum.default },
    { 'h-8 w-8 text-[17px]': props.size === AirlineIconSizeEnum.large },
  ];
</script>
